import { Controller } from '@hotwired/stimulus';
const controller = class extends Controller {
    constructor(context) {
        super(context);
        this.__stimulusLazyController = true;
    }
    initialize() {
        if (this.application.controllers.find((controller) => {
            return controller.identifier === this.identifier && controller.__stimulusLazyController;
        })) {
            return;
        }
        import('/home/justifit-moncompte-be/htdocs/moncompte.justifit.be/releases/2026-11-05-15-04-35-v3.66.0/assets/controllers/self_onboarding/user_password_controller.js').then((controller) => {
            this.application.register(this.identifier, controller.default);
        });
    }
};
export { controller as default };